export default __webpack_public_path__ + "static/media/324.8c3e89b3.png";